import { DKLabel, DKButton, TOAST_TYPE } from 'deskera-ui-library';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import RouteManager, { PAGE_ROUTES } from '../../managers/RouteManager';

import { useDispatch, useSelector } from "react-redux";
import {
  fetchContactCustomNumberFormat,
  selectContactCustomNumbersFormats
} from '../../Redux/Slices/CustomNumberFormat';
import CustomNumberFormatService from '../../services/CustomNumberFormat';
import CustomNumberFormat from '../../SharedComponents/CustomNumberFormat/CustomNumberFormat';
import PopupWrapper, { PopupClickActionType } from '../../SharedComponents/PopupWrapper';
import Utility, { deepClone } from '../../utility/Utility';
import { POPUP_CLICK_TYPE, POPUP_TYPE } from '../../constants/Enums';
import {
  CUSTOM_NUMBER_INPUT_MODULES,
  POPUP_CALLBACKS_TYPE,
  BtnType,
  CallBackPayloadType,
  ReactSelectOptionsType,
  UpdateCallBacksRefType
} from './Other';
import Popup from '../common/Popup';

type SequenceReactSelectOptions = ReactSelectOptionsType<string, string>;

interface AddSequenceNumberFormatState {
  contact: Object1;
}

interface Object1 {
  sequenceList: [];
  selectedSequenceCode: SequenceReactSelectOptions;
  options: SequenceReactSelectOptions[];
}

interface Data {
  module: string;
  application: string;
  prefix: string;
  prefixSeparator: string;
  suffix: string;
  suffixSeparator: string;
  sequenceLength: string;
  nextCode: string;
  sequenceCode: string;
  isDefault: boolean;
}

const SequenceNumberFormat: React.FC = (props: any) => {
  const { t, i18n } = useTranslation();
  const initialState: AddSequenceNumberFormatState = {
    contact: {
      sequenceList: [],
      selectedSequenceCode: { label: '', value: '' },
      options: [{ label: '', value: '' }]
    }
  };

  const refInitialState: UpdateCallBacksRefType = {
    pushDataToParent: { type: POPUP_CALLBACKS_TYPE.NONE },
    storeCallbacksRef: { updateContact: 'click' }
  };

  const [sequenceNumberFormat, setSequenceNumberFormat] =
    useState<AddSequenceNumberFormatState>(deepClone(initialState));
  const [addSequenceFormatPopUp, setAddSequenceFormatPopUp] =
    useState<boolean>(false);
  const [module, setModule] = useState<string>('PEOPLE_EMPLOYEE');
  const sequenceFormatRef = useRef<UpdateCallBacksRefType>(refInitialState);
  const contactFormat = useSelector(selectContactCustomNumbersFormats);
  const dispatch = useDispatch();

  const popupBtnConfigForAddSequenceFormat: BtnType[] = [
    {
      title: t(`SETTINGS.SEQUENCE_NUMBER_FORMAT.BUTTON.CANCEL`),
      class: 'border-m mr-s',
      clickAction: POPUP_CLICK_TYPE.CLOSE_POPUP
    },
    {
      title: t(`SETTINGS.SEQUENCE_NUMBER_FORMAT.BUTTON.SAVE`),
      class: 'bg-app text-white mr-ss',
      clickAction: POPUP_CLICK_TYPE.ADD_SEQUENCE_FORMAT
    }
  ];

  const catchClicks = (click: PopupClickActionType) => {
    switch (click.type) {
      case POPUP_CLICK_TYPE.CLOSE_POPUP:
        setAddSequenceFormatPopUp(false);
        break;
      case POPUP_CLICK_TYPE.ADD_SEQUENCE_FORMAT:
        sequenceFormatRef.current.storeCallbacksRef.createSequenceFormat();
        break;
    }
  };

  const parentChildInteraction = (passingData: CallBackPayloadType) => {
    switch (passingData.type) {
      case POPUP_CALLBACKS_TYPE.CLOSE_POPUP:
        setAddSequenceFormatPopUp(false);
        fetchUpdatedCustomNumberFormat();
        break;
      case POPUP_CALLBACKS_TYPE.SAVE_CUSTOM_NUMBER:
        sequenceFormatRef.current.storeCallbacksRef.createSequenceFormat =
          passingData.data;
        break;
    }
  };

  const fetchUpdatedCustomNumberFormat = () => {
    switch (module) {
      case CUSTOM_NUMBER_INPUT_MODULES.PEOPLE_EMPLOYEE:
        dispatch(fetchContactCustomNumberFormat());
        break;
    }
  };

  useEffect(() => {
    fetchUpdatedCustomNumberFormat();
    RouteManager.setPresenter({ props });
    console.log(props,"------",sequenceNumberFormat,"useeffect1");
    const newState = sequenceNumberFormat;

    newState.contact.sequenceList = contactFormat;
    const contactOptions: SequenceReactSelectOptions[] = [];
    contactFormat.forEach((contact: any) => {
      if (contact.isDefault) {
        newState.contact.selectedSequenceCode = {
          label: contact.sequenceCode,
          value: contact.id
        };
      }
      contactOptions.push({
        label: contact.sequenceCode,
        value: contact.id
      });
    });
    contactOptions.push({
      label: '+ Add New',
      value: '+ Add New'
    });
    newState.contact.options = contactOptions;

    setSequenceNumberFormat({ ...newState });
  }, []);

  useEffect(() => {
    
    console.log(props,"------",sequenceNumberFormat,"useeffect2");
    if (!Utility.isEmpty(contactFormat)) {
      const newState = sequenceNumberFormat;
      newState.contact.sequenceList = contactFormat;
      const contactOptions: SequenceReactSelectOptions[] = [];
      contactFormat.forEach((contact: any) => {
        if (contact.isDefault) {
          newState.contact.selectedSequenceCode = {
            label: contact.sequenceCode,
            value: contact.id
          };
        }
        contactOptions.push({
          label: contact.sequenceCode,
          value: contact.id
        });
      });
      contactOptions.push({
        label: '+ Add New',
        value: '+ Add New'
      });
      newState.contact.options = contactOptions;
      setSequenceNumberFormat({ ...newState });
    }
  }, [contactFormat]);

  const updateSequenceNumberFormat = (value: any | null, method: string) => {
    const newState = sequenceNumberFormat;
    const obj = {
      label: '+ Add New',
      value: '+ Add New'
    };
    if (newState && value) {
      if (obj.label === value.label) {
        if (method === 'people_employee') {
          setModule(CUSTOM_NUMBER_INPUT_MODULES.PEOPLE_EMPLOYEE);
        }
        setAddSequenceFormatPopUp(true);
      } else {
        if (method === 'people_employee') newState.contact.selectedSequenceCode = value;
      }
    }
    setSequenceNumberFormat({ ...newState });
  };

  const onCancelButton = () => {
    RouteManager.navigateToPage(PAGE_ROUTES.SETTINGS);
  };

  const onConfirmButton = () => {
    const payloadForContact = {
      module: 'PEOPLE_EMPLOYEE',
      application: 'PEOPLE',
      sequenceId: sequenceNumberFormat.contact.selectedSequenceCode.value
    };
    Promise.all([
      CustomNumberFormatService.changeCustomNumberFormat(payloadForContact)
    ])
      .then((responses) => {
        dispatch(fetchContactCustomNumberFormat());
        RouteManager.navigateToPage(PAGE_ROUTES.SETTINGS);
      })
      .catch((errors) => {
        console.error('Error altering formats: ', errors);
      });
  };

  return (
    <div className="w-full flex flex-col items-center">
      <div className="text-centre w-4/12">
        <span
          style={{
            fontWeight: 'bold',
            fontSize: '20px'
          }}
        >
          {"Sequence Number Setting"}
        </span>
        <div className="mt-2 ml-5 text-left">
          <p>
            {"You can set 1 default sequence number for each type of document and change them later"}
          </p>
        </div>
      </div>
      <div className="ml-5 mt-4 w-4/12 bg-white border-radius-m border-m p-r border-box shadow-s">
        <div className="row justify-content-between">
          <DKLabel
            text={"Document"}
            className="fw-m mt-m fs-m"
          />
          <DKLabel
            text={"Default Sequence Number"}
            className="fw-m mt-m fs-m"
          />
        </div>
        <div className="row justify-content-between align-item-center mt-r">
          <div>
          <DKLabel
            text={"Employee"}
            className="fw-m fs-m"
          />
          </div>
          <div style ={{width:"200px"}}>
            <Select
              options={sequenceNumberFormat.contact.options}
              value={sequenceNumberFormat.contact.selectedSequenceCode}
              onChange={(value) => {
                updateSequenceNumberFormat(value, 'people_employee');
              }}
              styles={{
                menuPortal: (provided: any, state: any) => ({
                  ...provided,
                  zIndex: 9999
                })
              }}
              menuPlacement={'auto'}
              menuPosition={'fixed'}
              menuPortalTarget={document.body}
              menuShouldScrollIntoView={false}
            />
          </div>
        </div>
        <div className="parent-width ">
            <div className="row  align-item-center mt-r">
              <DKButton
                title={`Cancel`}
                className="border-m mr-r"
                onClick={onCancelButton}
              />
              <DKButton
                title={'Confirm'}
                className={`mr-s p-1 ${
                  `bg-app text-white` 
                }`}
                onClick={() => onConfirmButton()}
              />
            </div>
          </div>
      </div>
      {console.log(addSequenceFormatPopUp,"shshs")}
      {addSequenceFormatPopUp && (
        <Popup
          popupClass = "sequence-number-popup"
          // clickAction={catchClicks}
          // type={POPUP_TYPE.POPUP}
          // title={t(
          //   `SETTINGS.SEQUENCE_NUMBER_FORMAT.CUSTOM_DOCUMENT_NUMBERING_FORMAT`
          // )}
          // btnList={popupBtnConfigForAddSequenceFormat}
          // height={'35%'}
          // width={'45%'}
        >
          <div className="row justify-content-between">
          <DKLabel className="fw-m fs-l" text="Custom Document Numbering Format" />
          <div className="d-flex">
            <DKButton title="Save" className="bg-app  text-white"  onClick={()=>sequenceFormatRef.current.storeCallbacksRef.createSequenceFormat()} />
            <DKButton title="Cancel" className=" border-m bg-gray1  ml-m" onClick={()=>setAddSequenceFormatPopUp(false)}  />
          </div>
        </div>
          {console.log("inside")}
          <CustomNumberFormat
            passingInteraction={(callback: CallBackPayloadType) => {
              parentChildInteraction(callback);
            }}
            documentType={module}
          />
        </Popup>
      )}
    </div>
  );
};
export default SequenceNumberFormat;
